export default {
  en: {
    currentItemAria: 'Current: {{item}}',
  },
  ru: {
    currentItemAria: 'Текущее значение: {{item}}',
  },
  de: {
    currentItemAria: 'Aktuell: {{item}}',
  },
  pt: {
    currentItemAria: 'Atual: {{item}}',
  },
  fr: {
    currentItemAria: 'Actuel : {{item}}',
  },
  es: {
    currentItemAria: 'Actual: {{item}}',
  },
};
